'use client'

import type { Token } from '@polaris/core/models'
import Image, { type ImageProps } from 'next/image'
import { useState } from 'react'
import { cn } from '@/src/utils/styles'

interface TokenImgProps {
  fallbackContainerClassName: string
  fallbackTextElementClassName: string
  charLimit?: number
  alt?: string
}

export default function TokenImg({
  src,
  ticker,
  fallbackContainerClassName,
  fallbackTextElementClassName,
  charLimit = 3,
  width = 32,
  height = 32,
  alt,
  ...rest
}: Partial<Pick<Token, 'ticker'>> &
  Partial<Omit<ImageProps, 'alt' | 'onError'>> &
  Partial<TokenImgProps>) {
  const [isError, setIsError] = useState(false)

  const tokenName = alt ? alt : ticker

  if (!src || (typeof src === 'string' && src.trim() === '') || isError)
    return (
      <div
        className={cn(
          'flex items-center justify-center size-10 bg-surface2 rounded-full',
          fallbackContainerClassName,
        )}
      >
        <span
          className={cn('text-secondary text-xs', fallbackTextElementClassName)}
        >
          {tokenName
            ? tokenName.slice(0, charLimit).toUpperCase()
            : 'TOK'.slice(0, charLimit)}
        </span>
      </div>
    )

  return (
    <Image
      src={src}
      alt={`${ticker} image`}
      onError={() => {
        setIsError(true)
      }}
      width={width}
      height={height}
      className={cn('rounded-full', rest.className)}
      style={{
        width: `${width}px`,
        height: `${height}px`,
        objectFit: 'cover',
        borderRadius: '9999px',
      }}
      {...rest}
    />
  )
}
